<div class="not-found__container">
    <h1>Not found</h1>
    <span>The page you are looking for could not be found.</span>
    <button [ax-button]="'primary'" [routerLink]="'/'">Back to home</button>
</div>